"use client";

import {
  FeatureHighlight,
  PriceCalculatorSteps,
} from "@/components/shared/public";
import type { MeasurementServicePricingConfig } from "@/lib/pricing";
import { useTranslations } from "next-intl";
import { calculator } from "../../../../public/images/measurement-service";

type PriceCalculationProps = {
  pricingConfig: MeasurementServicePricingConfig;
};

const PriceCalculation = ({ pricingConfig }: PriceCalculationProps) => {
  const t = useTranslations("measurementService.priceCalculation");

  return (
    <div className="bg-secondary">
      <div className="gs--page-column py-16">
        <div className="flex flex-col">
          <FeatureHighlight
            src={calculator}
            alt={"floor plan logo"}
            title={t("title")}
            text={""}
          />
          <PriceCalculatorSteps pricingConfig={pricingConfig} />
        </div>
      </div>
    </div>
  );
};

export default PriceCalculation;
